module.exports = __webpack_public_path__ + "img/how_it_works.bfb34d5a.jpg";